import { reduxKey } from './constants';
import { NotificationQueueStateSlice } from './types';
import { createSelector } from 'reselect';

const emptyQueue = []; // here so that memoization doesn't break

function getNotificationState(state): NotificationQueueStateSlice {
  return state[reduxKey] || { default: [] };
}

export const getNotificationQueue = createSelector(
  getNotificationState,
  (_, queue) => queue ?? 'default',
  (state, queue) => {
    return state[queue] ?? emptyQueue;
  }
);

export const getTopNotification = createSelector(
  getNotificationState,
  (_, queue) => queue ?? 'default',
  (state, queue) => {
    return state[queue][0];
  }
);
